import { Box, Button, Checkbox, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import bg_img from "../../assets/Cover.png";
import refer from "../../assets/refer.png";
import { useQuery } from "@apollo/client";
import { GET_REFERRAL_LINK } from "../../Utils/Queries";
import { BsCopy } from "react-icons/bs";

import { IconButton } from "@mui/material";

// Assets
import whatsapp from "../../assets/Icons/whatsapp 1.svg";
import twitter from "../../assets/Icons/twitter 1 (1).svg";
import facebook from "../../assets/Icons/facebook 1 (1).svg";
import { MdOutlineDone } from "react-icons/md";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { lg: 350, md: 350, sm: 350, xs: 300 },
  boxShadow: 24,
  p: 3,
  zIndex: 10000,
  borderRadius: "20px",
  maxHeight: "90vh",
  overflowY: "auto",
};

const ShareEarn = () => {
  const [open, setOpen] = useState(false);

  const [showCard, setShowCard] = useState(false);

    useEffect(() => {
    const promoStatus = localStorage.getItem("Promo_popup");
    if (promoStatus !== "true") {
      setOpen(true);
    }
  }, []);

  const { data: linkData, loading } = useQuery(GET_REFERRAL_LINK);
  const referralLink = linkData?.getReferralLink?.referralLink || "Loading...";

  const [check, setCheck] = useState(false)

  const handleChangeValue = (e) => {
    const isChecked = e.target.checked;
    localStorage.setItem("Promo_popup", isChecked.toString());
    setCheck(isChecked);
    setOpen(false);
  };
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        sx={style}
        style={{
          background: `url(${bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Box
          sx={{
            py: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              backgroundImage: `url(${refer})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100px",
              width: "85%",
              borderRadius: "20px",
            }}
          />
          <Typography
            sx={{
              color: "#02972F",
              fontWeight: 700,
              fontSize: "35px",
              textAlign: "center",
              lineHeight: "35px",
              mt: 2,
            }}
          >
            Share and Earn <br />
            on Mamaket!
          </Typography>
          <Typography sx={{ textAlign: "center", mt: 2 }}>
            Earn $0.25 rewards every time someone joins through your link.
          </Typography>
          {showCard ? (
            <Box
              sx={{
                border: "1px solid #02B237",
                borderRadius: "20px",
                bgcolor: "#fff",
                p: 2,
                width: "85%",
                mt: 2,
              }}
            >
              <Typography>Invite friends:</Typography>
              {loading ? "Loading..." : <SocialShare link={referralLink} />}
            </Box>
          ) : (
            <Button
              onClick={() => setShowCard(true)}
              sx={{
                width: "85%",
                bgcolor: "#02972f",
                mt: 2,
                height: "50px",
                color: "#fff",
                borderRadius: "50px",
              }}
            >
              Invite Friends
            </Button>
          )}
        </Box>
        <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', columnGap:1}}>
<Checkbox checked={check} onChange={handleChangeValue} />
        <Typography sx={{color:'#000'}}>Don't show this again</Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default ShareEarn;

const SocialShare = ({ link }) => {




  const shareOnTwitter = () => {
    const tweetText = encodeURIComponent(
      `Quick win! Sign up on Mamaket using my link and you’ll get $0.25 free just for joining. Let’s earn together!: ${link}`
    );
    const url = `https://twitter.com/intent/tweet?text=${tweetText}`;
    window.open(url, "_blank");
  };

  const shareOnFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      link
    )}`;
    window.open(url, "_blank");
  };

  const shareOnWhatsApp = () => {
    const message = `Quick win! Sign up on Mamaket using my link and you’ll get $0.25 free just for joining. Let’s earn together!: ${link}`;
    const url = `whatsapp://send?text=${encodeURIComponent(message)}`;
    window.open(url);
  };

  const [copied, setCopied] = useState(false)

    const handleCopy = () => {
      navigator.clipboard.writeText(link).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      });
    };

  return (
    <>
      <Box sx={{mt:1, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
       <Box>
         <IconButton onClick={shareOnFacebook}>
          <img src={facebook} alt="facebook_icon" />
        </IconButton>
        <IconButton onClick={shareOnTwitter}>
          <img src={twitter} alt="twitter_icon" />
        </IconButton>
        <IconButton onClick={shareOnWhatsApp}>
          <img src={whatsapp} alt="whatsapp_icon" />
        </IconButton>
       </Box>
        <Box>
          {copied ? (

               <IconButton sx={{ml:3}}>
                <MdOutlineDone />
               </IconButton>
              ):(
                <IconButton sx={{ml:3}} onClick={handleCopy}>

                <BsCopy />
                </IconButton>
              )}
              </Box>
      </Box>
    </>
  );
};
